import React, { useCallback } from 'react';
import { Button, IconButton } from '@mui/material';
import { useMediaQuery, useTheme } from '@mui/material';
import ChatBubble from '@mui/icons-material/ChatBubble';
import { useIntl } from 'react-intl';

declare global {
	interface Window {
		$crisp: any[];
	}
}

interface Props {
	className?: string;
	variant?: 'button' | 'link';
}

const CrispCTAButton = (props: Props) => {
	const intl = useIntl();
	const theme = useTheme();
	const isXs = useMediaQuery(theme.breakpoints.down('sm'));
	const { className, variant = 'button' } = props;

	const handleOnClick = useCallback(() => {
		if (window.location.hostname === 'studio.nuqlea.com') {
			window.$crisp.push(['do', 'chat:open']);

			(globalThis as any).dataLayer?.push({
				event: 'ns_click_boton_acopiar',
			});
		}
	}, []);

	if (variant === 'link') {
		return (
			<Button
				variant='text'
				onClick={handleOnClick}
				className={className}
				sx={{
					textAlign: 'center',
					fontSize: '12px',
					textTransform: 'none',
					color: 'inherit',
					'&:hover': {
						background: 'transparent',
						textDecoration: 'underline',
					},
				}}
			>
				{intl.formatMessage({ id: 'crisp.call_to_action_text' })}
			</Button>
		);
	}

	return isXs ? (
		<IconButton size='large' className='text-blue-600 p-0' onClick={handleOnClick}>
			<ChatBubble className='w-[1.5rem] h-[1.5rem]' />
		</IconButton>
	) : (
		<Button
			size='small'
			variant='contained'
			className={className ?? 'text-blue-600'}
			id='speak-with-nuqlea-agent-button'
			sx={{
				backgroundColor: '#EAEFFF',
				':hover': { backgroundColor: '#EAEFFF' },
				border: '1px solid #EAEFFF', // to have same height as InfoButton
				borderBottomWidth: '2px',
			}}
			startIcon={<ChatBubble />}
			onClick={handleOnClick}
		>
			{intl.formatMessage({ id: 'crisp.call_to_action_text' })}
		</Button>
	);
};

export default CrispCTAButton;
